import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation/src/elevation";
import {Container} from "@pg-design/grid-module";
import {flex, onDesktop, pb, pt, pv, textAlign, w100} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {useCookieBotObserver} from "../../../navigation/hooks/use_cookie_bot_observer";
import {SlotOrderType} from "../../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../../search/constants/search_form_with_drawer_height";
import {useSearchForm} from "../../../search/hooks/use_search_form";
import {tdaDesktopHeight} from "../../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../../store/hooks";
import {ILatestQuery} from "../../../utils/latest_query";
import {useOffersViewsUrl} from "../../hooks/use_offers_views_url";
import {useListingStickyHeaderBehavior} from "../hooks/use_listing_sticky_header_behavior";

interface IProps {
    latestQuery?: ILatestQuery;
    hideBottomPadding?: boolean;
}

export const ListingStickyHeader = (props: IProps) => {
    const {hideBottomPadding, latestQuery} = props;

    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    const {mapUrl} = useOffersViewsUrl();
    const stickyHeaderVisibility = useAppSelector((state) => state.offerListing.stickyHeaderVisibility);
    const isHeaderVisible = stickyHeaderVisibility === 1;

    const {wrapperRef, currentHeaderHeight} = useListingStickyHeaderBehavior({isMobile: Boolean(isMobile)});

    const {isLocationSearchOpen} = useSearchForm();

    return (
        <div ref={wrapperRef} css={[headerWrapperStyle, headerWrapperStickyStyle(isHeaderVisible, isLocationSearchOpen)]}>
            {!isMobile && !!latestQuery && (
                <div css={[stickyBarShell, isHeaderVisible && stickyBarShellVisible]}>
                    <Container css={containerStyle}>
                        {isHeaderVisible && (
                            <SearchFormWithDrawer
                                listFriendlyLink={({friendlySlug, offerListSubFilterSlug}) => {
                                    return offerListSubFilterSlug
                                        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
                                        : rpAppLink.offer.listFriendly({friendlySlug});
                                }}
                                abroadListFriendlyLink={(params) => rpAppLink.offer.listFriendlyAbroad(params)}
                                multiRegionLink={rpAppLink.offer.multiList}
                                latestQuery={latestQuery}
                                sortActive
                                shouldRenderListBackBtn
                                // TODO: Sometimes blend is relative to their elements, navigationHeight should be removed from atoms/DesktopBlend implementation
                                blendTop={`${currentHeaderHeight - navigationHeight}px`}
                                blendHeightDecrease={`${currentHeaderHeight + navigationHeight + tdaDesktopHeight * 2 + searchFormWithDrawerHeight}px`}
                                className="isInNavigationBar"
                                slotOrder={SlotOrderType.ROW_REVERSE}
                                hideBottomPadding={hideBottomPadding}
                                disableFilterAutoShowcase
                                disableLocationSearch={isCookieBotOpen}
                            />
                        )}

                        <Button href={mapUrl} iconLeft={BrandMapPinIcon} variant="brand_icon" size="medium" css={buttonStyle}>
                            Zobacz na mapie
                        </Button>
                    </Container>
                </div>
            )}
        </div>
    );
};

const headerWrapperStyle = css`
    display: none;

    ${onDesktop(css`
        display: block;
        position: sticky;
        top: 0;
        height: 0;
        pointer-events: none;
    `)};
`;

const headerWrapperStickyStyle = (isHeaderVisible: boolean, isLocationSearchOpen: boolean) =>
    isHeaderVisible
        ? css`
              z-index: ${isLocationSearchOpen ? 51 : 22};
          `
        : css`
              z-index: -1;
          `;

const stickyBarShell = css`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    ${pv(1)};
    background: var(--colors-white);
    width: 100%;
    pointer-events: none;
    transition:
        transform 0.15s ease-out,
        box-shadow 0s linear;
    will-change: transform;
    transform: translateY(-100%);
    box-shadow: none;
`;

const stickyBarShellVisible = css`
    z-index: 22;
    transform: translateY(0);
    pointer-events: auto;
    transition:
        transform 0.15s ease-out,
        box-shadow 0.15s ease-out;
    ${elevation(4)};
`;

const buttonStyle = css`
    transition-duration: unset;
    transition-timing-function: unset;
    overflow: initial;
`;

const containerStyle = css`
    ${textAlign("right")};
    ${flex("center", "flex-end")};
    ${w100};

    > div:first-of-type {
        ${w100};
    }

    .isInNavigationBar {
        ${pb(0)};
        > div:nth-of-type(2) {
            ${pt(0)};
        }
    }
`;
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation/src/elevation";
import {Container} from "@pg-design/grid-module";
import {flex, onDesktop, pb, pt, pv, textAlign, w100} from "@pg-design/helpers-css";
import {BrandMapPinIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

import {useCookieBotObserver} from "../../../navigation/hooks/use_cookie_bot_observer";
import {SlotOrderType} from "../../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../../search/constants/search_form_with_drawer_height";
import {useSearchForm} from "../../../search/hooks/use_search_form";
import {tdaDesktopHeight} from "../../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../../store/hooks";
import {ILatestQuery} from "../../../utils/latest_query";
import {useOffersViewsUrl} from "../../hooks/use_offers_views_url";
import {useListingStickyHeaderBehavior} from "../hooks/use_listing_sticky_header_behavior";

interface IProps {
    latestQuery?: ILatestQuery;
    hideBottomPadding?: boolean;
}

export const ListingStickyHeader = (props: IProps) => {
    const {hideBottomPadding, latestQuery} = props;

    const {isMobile} = useUserDevice();
    const {isCookieBotOpen} = useCookieBotObserver();
    const {mapUrl} = useOffersViewsUrl();
    const stickyHeaderVisibility = useAppSelector((state) => state.offerListing.stickyHeaderVisibility);
    const isHeaderVisible = stickyHeaderVisibility === 1;

    const {wrapperRef, currentHeaderHeight} = useListingStickyHeaderBehavior({isMobile: Boolean(isMobile)});

    const {isLocationSearchOpen} = useSearchForm();

    return (
        <div ref={wrapperRef} css={[headerWrapperStyle, headerWrapperStickyStyle(isHeaderVisible, isLocationSearchOpen)]}>
            {!isMobile && !!latestQuery && (
                <div css={[stickyBarShell, isHeaderVisible && stickyBarShellVisible]}>
                    <Container css={containerStyle}>
                        {isHeaderVisible && (
                            <SearchFormWithDrawer
                                listFriendlyLink={({friendlySlug, offerListSubFilterSlug}) => {
                                    return offerListSubFilterSlug
                                        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
                                        : rpAppLink.offer.listFriendly({friendlySlug});
                                }}
                                abroadListFriendlyLink={(params) => rpAppLink.offer.listFriendlyAbroad(params)}
                                multiRegionLink={rpAppLink.offer.multiList}
                                latestQuery={latestQuery}
                                sortActive
                                shouldRenderListBackBtn
                                // TODO: Sometimes blend is relative to their elements, navigationHeight should be removed from atoms/DesktopBlend implementation
                                blendTop={`${currentHeaderHeight - navigationHeight}px`}
                                blendHeightDecrease={`${currentHeaderHeight + navigationHeight + tdaDesktopHeight * 2 + searchFormWithDrawerHeight}px`}
                                className="isInNavigationBar"
                                slotOrder={SlotOrderType.ROW_REVERSE}
                                hideBottomPadding={hideBottomPadding}
                                disableFilterAutoShowcase
                                disableLocationSearch={isCookieBotOpen}
                            />
                        )}

                        <Button href={mapUrl} iconLeft={BrandMapPinIcon} variant="brand_icon" size="medium" css={buttonStyle}>
                            Zobacz na mapie
                        </Button>
                    </Container>
                </div>
            )}
        </div>
    );
};

const headerWrapperStyle = css`
    display: none;

    ${onDesktop(css`
        display: block;
        position: sticky;
        top: 0;
        height: 0;
        pointer-events: none;
    `)};
`;

const headerWrapperStickyStyle = (isHeaderVisible: boolean, isLocationSearchOpen: boolean) =>
    isHeaderVisible
        ? css`
              z-index: ${isLocationSearchOpen ? 51 : 22};
          `
        : css`
              z-index: -1;
          `;

const stickyBarShell = css`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    ${pv(1)};
    background: var(--colors-white);
    width: 100%;
    pointer-events: none;
    transition:
        transform 0.15s ease-out,
        box-shadow 0s linear;
    will-change: transform;
    transform: translateY(-100%);
    box-shadow: none;
`;

const stickyBarShellVisible = css`
    z-index: 22;
    transform: translateY(0);
    pointer-events: auto;
    transition:
        transform 0.15s ease-out,
        box-shadow 0.15s ease-out;
    ${elevation(4)};
`;

const buttonStyle = css`
    transition-duration: unset;
    transition-timing-function: unset;
    overflow: initial;
`;

const containerStyle = css`
    ${textAlign("right")};
    ${flex("center", "flex-end")};
    ${w100};

    > div:first-of-type {
        ${w100};
    }

    .isInNavigationBar {
        ${pb(0)};
        > div:nth-of-type(2) {
            ${pt(0)};
        }
    }
`;
